import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/outlet/staff')({
  loader: () => {
    return {
      crumb: 'Karyawan',
    }
  },
})
